import { render, staticRenderFns } from "./AboutInfo.vue?vue&type=template&id=3da71a40&scoped=true"
import script from "./AboutInfo.vue?vue&type=script&lang=js"
export * from "./AboutInfo.vue?vue&type=script&lang=js"
import style0 from "./AboutInfo.vue?vue&type=style&index=0&id=3da71a40&prod&lang=scss&scoped=true"
import style1 from "./AboutInfo.vue?vue&type=style&index=1&id=3da71a40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da71a40",
  null
  
)

export default component.exports